(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msiv-video-popup')) {
    customElements.define('msiv-video-popup', class extends HTMLElement {
      connectedCallback() {
        this.playbackToken = 0;
        this.dialog = this.querySelector('.msiv-video-dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.frame = this.dialog.querySelector('.msiv-video-dialog__frame');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('a.msiv-video-trigger').forEach((link) => {
          if (this.videoSource(link.href)) {
            link.setAttribute('aria-haspopup', 'dialog');
            link.setAttribute('aria-controls', this.dialog.id);
          }
        });
        // Activate a completed tap directly: iOS can consume the first native click as hover.
        this.addEventListener('touchstart', (event) => {
          this.touchTap = null;
          const link = event.target.closest('a.msiv-video-trigger');
          if (event.defaultPrevented || event.touches.length !== 1 || !link || !this.videoSource(link.href)) return;
          const touch = event.touches[0];
          this.touchTap = { link, id: touch.identifier, x: touch.clientX, y: touch.clientY, time: event.timeStamp };
        }, { ...options, passive: true });
        this.addEventListener('touchmove', (event) => {
          const tap = this.touchTap;
          if (!tap) return;
          const touch = Array.from(event.touches).find((item) => item.identifier === tap.id);
          if (event.touches.length !== 1 || !touch || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 10) this.touchTap = null;
        }, { ...options, passive: true });
        this.addEventListener('touchcancel', () => { this.touchTap = null; }, options);
        this.addEventListener('contextmenu', () => { this.touchTap = null; }, options);
        this.addEventListener('touchend', (event) => {
          const tap = this.touchTap;
          this.touchTap = null;
          if (!tap || event.defaultPrevented || !event.cancelable || event.touches.length || event.changedTouches.length !== 1 || event.timeStamp - tap.time > 500) return;
          const touch = event.changedTouches[0];
          if (touch.identifier !== tap.id || Math.hypot(touch.clientX - tap.x, touch.clientY - tap.y) > 10) return;
          const endLink = document.elementFromPoint(touch.clientX, touch.clientY)?.closest('a.msiv-video-trigger');
          if (endLink !== tap.link || !this.contains(tap.link) || !this.videoSource(tap.link.href)) return;
          event.preventDefault();
          tap.link.click();
        }, { ...options, passive: false });
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a.msiv-video-trigger');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const source = this.videoSource(link.href);
          if (!source) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.opener = link;
          this.dialog.showModal();
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          const iframe = document.createElement('iframe');
          iframe.src = source;
          iframe.title = this.dialog.getAttribute('aria-label');
          iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.frame.replaceChildren(iframe);
          const playbackToken = this.playbackToken;
          this.constructor.youtube().then((YT) => {
            if (!this.dialog.open || playbackToken !== this.playbackToken || !this.frame.contains(iframe)) return;
            const markPlaying = () => {
              if (this.dialog.open && playbackToken === this.playbackToken) this.dialog.classList.add('is-playing');
            };
            this.player = new YT.Player(iframe, {
              events: {
                onReady: (event) => {
                  if (event.target.getPlayerState() === YT.PlayerState.PLAYING) markPlaying();
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) markPlaying();
                }
              }
            });
          }).catch(() => {});
        }, options);
        this.dialog.querySelector('.msiv-video-dialog__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.reset(), options);
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.reset();
        this.events?.abort();
      }

      reset() {
        this.touchTap = null;
        this.playbackToken += 1;
        this.player?.destroy();
        this.player = null;
        this.dialog?.classList.remove('is-playing');
        this.frame?.replaceChildren();
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      static youtube() {
        if (window.YT?.Player) return Promise.resolve(window.YT);
        if (!this.youtubeReady) {
          this.youtubeReady = new Promise((resolve, reject) => {
            const previous = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = () => {
              try {
                if (typeof previous === 'function') previous();
              } finally {
                resolve(window.YT);
              }
            };
            let script = document.querySelector('script[src="https://www.youtube.com/iframe_api"], script[src="https://www.youtube.com/player_api"]');
            const needsScript = !script;
            if (needsScript) {
              script = document.createElement('script');
              script.src = 'https://www.youtube.com/iframe_api';
              script.async = true;
            }
            script.addEventListener('error', () => {
              script.remove();
              this.youtubeReady = null;
              reject(new Error('YouTube API unavailable'));
            }, { once: true });
            if (needsScript) document.head.appendChild(script);
          });
        }
        return this.youtubeReady;
      }

      videoSource(href) {
        try {
          const url = new URL(href, window.location.href);
          const host = url.hostname.replace(/^www\./, '');
          const parts = url.pathname.split('/').filter(Boolean);
          let id;
          if (host === 'youtu.be') id = parts[0];
          if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
            id = parts[0] === 'watch' ? url.searchParams.get('v') : ['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : null;
          }
          if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return null;
          const source = new URL('https://www.youtube-nocookie.com/embed/' + id);
          const mobile = window.matchMedia('(max-width: 1023px), (max-height: 600px) and (pointer: coarse)').matches;
          source.searchParams.set('autoplay', mobile ? '0' : '1');
          source.searchParams.set('enablejsapi', '1');
          source.searchParams.set('origin', window.location.origin);
          source.searchParams.set('playsinline', '1');
          source.searchParams.set('rel', '0');
          const time = url.searchParams.get('start') || url.searchParams.get('t');
          if (time) {
            const match = time.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
            const seconds = /^\d+$/.test(time) ? Number(time) : match ? Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0) : 0;
            if (seconds > 0) source.searchParams.set('start', seconds);
          }
          return source.href;
        } catch {
          return null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
